/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Defines the network mode that the VM can include
 */
export enum NetworkMode {
	USO = "uso",
	VHOST = "vhost",
	XDP = "xdp",
}
